export const pageTitle = (title) => {
  return (document.title = "Skew");
};
